import { QueryList } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subscription } from 'rxjs';

export function registerCloseOtherMenus(
  allTriggers: QueryList<MatMenuTrigger>
) {
  for (const trigger of allTriggers) {
    trigger.menuOpened.subscribe(() => {
      for (const other of allTriggers) {
        if (other !== trigger) other.closeMenu();
      }
    });
  }
}

export function registerCloseOtherSubMenus(
  allTriggers: QueryList<MatMenuTrigger>,
  subscriptions: Subscription[]
) {
  for (const trigger of allTriggers) {
    const sub = trigger.menuOpened.subscribe(() => {
      for (const other of allTriggers) {
        if (other !== trigger) other.closeMenu();
      }
    });
    subscriptions.push(sub);
  }
}

export function cleanUpSubscriptions(subscriptions: Subscription[]) {
  subscriptions.forEach((sub) => sub.unsubscribe());
  subscriptions = [];
}
